<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>

      <v-flex sm12 md12 lg8>
        <material-card color="orange"
                       :title="$t('page_404')"
                       :text="$t('page_404_descr')">


          <v-img :src="image"
                 height="100%" />
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    computed: {

      image: {
        get: function () {
          return '/assets/images/misc/Not_found_404.png'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Common/Page404.vue